<template>
  <b-card class="mb-5">
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard">{{ $t('dashboard') }}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/letter">{{ $t('letter') }}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="6" class="mt-3"> </b-col>
    </b-row>
    <div class="border-bottom mb-3" />
    <template v-if="isLoading">
      <div class="d-flex justify-content-center m-auto">
        <b-spinner
          style="width: 3rem; height: 3rem;"
          variant="primary"
          label="Loading..."
        ></b-spinner>
      </div>
    </template>
    <div v-else>
      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('letterNumber') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ model.letterNumber }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('createdBy') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ model.createdBy }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('letterType') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ model.letterType }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('letterPurpose') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ model.letterPurpose }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('letterStartDate') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ getDate(model.letterStartDate) }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('letterEndDate') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ getDate(model.letterEndDate) }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('createdAt') }}</label>
        </b-col>
        <b-col>
          <span class="text-capitalize">{{ getDate(model.createdAt) }}</span>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>

      <b-row class="mt-3 mb-3">
        <b-col md="2">
          <label class="labels">{{ $root.$t('letterOfAssignmentAttachments') }}</label>
        </b-col>
        <b-col>
          <div v-for="l in model.lampiran" :key="l.uuid">
              <b-img :src="l.url" style="width: 140px; height: 180px; margin: 12px 2px;" alt="l.url"/>
              <b-button variant="link" @click="downloadPicture(l.url)" target="_blank" v-b-tooltip.hover title="download">
                <b-icon variant="success" icon="download"></b-icon>
              </b-button>
          </div>
        </b-col>
        <b-col> </b-col>
        <b-col></b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      apiUrl: {
        letter: window.AppConfig.apiUrl + 'letter-of-assignment',
      },
      isLoading: false,
      model: {
        letterNumber: null,
        letterDate: null,
        letterType: null,
        letterPurpose: null,
        letterStartDate: null,
        letterEndDate: null,
        createdAt: null,
        updatedAt: null,
        uuid: null,
        letterOfAssignmentAttachments: [],
        lampiran: [],
        createdBy: {
          uuid: null,
          firstName: null,
          lastName: null,
          branch: null,
        },
      },
    };
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      if (this.$route.params.uuid !== undefined) {
        this.getLetterDetail();
      }
    },

    async getLetterDetail() {
      this.isLoading = true;
      const r = await this.$http.get(this.apiUrl.letter + '/' + this.$route.params.uuid);
      try {
        this.model.letterNumber = r.data?.letterNumber ?? '-';
        this.model.letterDate = r.data?.letterDate ?? '-';
        this.model.letterType = r.data?.letterOfAssignmentType?.name ?? '-';
        this.model.letterPurpose = r.data?.letterPurpose ?? '-';
        this.model.letterStartDate = r.data?.letterStartDate ?? '-';
        this.model.letterEndDate = r.data?.letterEndDate ?? '-';
        this.model.createdAt = r.data?.createdAt ?? '-';
        this.model.createdBy = r.data?.createdBy?.firstName + ' ' + r.data?.createdBy?.lastName ?? '-';
        this.model.letterOfAssignmentAttachments = r.data?.letterOfAssignmentAttachments.forEach(element => {
            this.model.lampiran.push(element)
        });
      } catch (error) {
        this.$store.dispatch('notification/error', error);
      } finally {
        this.isLoading = false;
      }
    },


    downloadPicture(uuid){
      let url = uuid
      
      window.open(url)
    },

    getDate(value){
        if(value !==null){
            return this.$moment(value).format('DD MMMM YYYY')
        }
    }
  },
};
</script>
